import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HttpStatus } from '@lentau/ui-kit/core/enums/http-status.enum';

export function handle302Interceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);

  return next(req).pipe(
    switchMap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const router: Router = injector.get(Router);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const body: any = event.body;

        if (body && event.status === HttpStatus.found) {
          router.navigateByUrl(body.Head?.Location ?? '/');
        }
      }

      return of(event);
    })
  );
}
